import axios from 'axios';
import {
  bus
} from '@/main';
import moment from 'moment';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery'); 
// You need a specific loader for CSS files
let checkMetadataOfPaperApiUrl = root.checkMetadataOfPaperApiUrl.link;
export default {
  name: 'update-paperpile-details',
  components: {
  },
  props: ['paperUpdateINFO'],
  data () {
    return {
      submitted:false,
      author:'',
      journal:'',
      topic:'',
      page_no:'',
      volume:'',
      publisher:'',
      number:'',
      abstract:'',
      pdf_id:'',
      issue:'',
      isSubmitted:false,
      yearList:[
        1950,
        1951,
        1952,
        1953,
        1954,
        1955,
        1956,
        1957,
        1958,
        1959,
        1960,
        1961,
        1962,
        1963,
        1964,
        1965,
        1966,
        1967,
        1968,
        1969,
        1970,
        1971,
        1972,
        1973,
        1974,
        1975,
        1976,
        1977,
        1978,
        1979,
        1980,
        1981,
        1982,
        1983,
        1984,
        1985,
        1986,
        1987,
        1988,
        1989,
        1990,
        1991,
        1992,
        1993,
        1994,
        1995,
        1996,
        1997,
        1998,
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020,
        2021,
        2022,
        2023
    ]
    }
  },
  computed: {

  },
  mounted () {
    this.topic = this.paperUpdateINFO.title || ''
    this.author = this.paperUpdateINFO.author || ''
    this.abstract = this.paperUpdateINFO.abstract || ''
    this.journal = this.paperUpdateINFO.journal || ''
    this.publisher = this.paperUpdateINFO.year || ''
    this.pdf_id = this.paperUpdateINFO.pdf_id || ''
    this.volume = this.paperUpdateINFO.volume || ''
    this.issue = this.paperUpdateINFO.issue || ''
    this.number = this.paperUpdateINFO.number || ''
    this.page_no = this.paperUpdateINFO.pages || ''
  },
  methods: {
    getPaperPileListAgain(){
      this.$store.dispatch('getAllPaperPileFun')
    },
    updatePaperpileBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        this.submitted =  true
        if(result){
          this.isSubmitted = true
          let payload = {
            title: this.topic,
            author:this.author,
            abstract:this.abstract,
            journal:this.journal,
            year:this.publisher,
            volume:this.volume,
            number:this.number,
            issue:this.issue,
            pages:this.page_no,
            pdf_id:this.pdf_id,
            id: this.paperUpdateINFO.id
          }
          axios.post(checkMetadataOfPaperApiUrl, payload)
            .then((res) => {  
              toast.success(res.data.msg || "Request processed successfully.");
              this.getPaperPileListAgain()
              this.closeUpdatePaperInfoPopup()
              this.submitted =  false
              this.isSubmitted = false
            }).catch((err) => {
              this.submitted =  false
              this.isSubmitted = false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeUpdatePaperInfoPopup(){
      bus.$emit('updatePaperPileDetailPopupStateBus', false);
      bus.$emit('addPaperPilePopupStateBus', false);
      bus.$emit('uploadPaperStateBus', false);
      $('body').removeClass('body_right_scroll_remove')
    }
  }
}